export default {
  name: "Tecate",
  favicon: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/logo.webp`,
  logo: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/logo.webp`,
  logoColor: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/logo-color.webp`,
  products: [
    {
      id: "tecate",
      image: {
        en: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/en/product-foward_lager.webp`,
        fr: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/fr/product-foward_lager.webp`,
      },
      name: {
        en: "Lager",
        fr: "Lager",
      },
      description: {
        en: "Tecate® Original is a full-bodied lager with a refreshing crisp malt flavor and a pleasant aftertaste – the way a Mexican cerveza should be.",
        fr: "Tecate® Original est une lager pleine de caractère avec une saveur de malt rafraîchissante et un arrière-goût agréable – comme toute cerveza mexicaine doit l'être.",
      },
      formats: [
        {
          image: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/en/information_render_can_473ml_tecate.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/fr/information_render_can_473ml_tecate.webp`,
          },
          details: {
            en: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/en/information_nft_can_473ml_tecate.webp`,
            fr: `${process.env.REACT_APP_AZURE_STORAGE}/tecate/fr/information_nft_can_473ml_tecate_fr.webp`,
          },
          name: {
            en: "Can 473ml",
            fr: "Canette 473ml",
          },
        },
      ],
    },
  ],
};
